import { render, staticRenderFns } from "./OwnershipChanges.vue?vue&type=template&id=57de5163&scoped=true"
import script from "./OwnershipChanges.vue?vue&type=script&lang=js"
export * from "./OwnershipChanges.vue?vue&type=script&lang=js"
import style0 from "./OwnershipChanges.vue?vue&type=style&index=0&id=57de5163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de5163",
  null
  
)

export default component.exports